import { View, Text, Button, Flex, Spinner, Card } from '@smarterservices/smarter-ui';
import CONSTANTS from '../../../config/constants';

/**
 * ConnectionToolsCard — Provides a reconnect button for the remote control session.
 *
 * Displayed in the sidebar when the co-browsing iframe is active.
 * Use this when the screen freezes, the page is refreshed, or the connection is lost.
 *
 * @param {Object} props
 * @param {Function} props.onReconnect - Callback to re-inject the remote control script
 * @param {boolean} props.isReconnecting - Whether a reconnect attempt is currently in progress
 * @returns {JSX.Element}
 */
function ConnectionToolsCard({ onReconnect, isReconnecting }) {
  return (
    <Card margin="small none none none">
      <Card.Header
        background="brand"
        padding={CONSTANTS.STYLES.CARD_HEADER_PADDING}
      >
        <Card.Title>
          <Text variant={CONSTANTS.STYLES.CARD_TITLE_VARIANT}>
            Connection Tools
          </Text>
        </Card.Title>
      </Card.Header>
      <Card.Body padding={CONSTANTS.STYLES.CARD_BODY_PADDING}>
        <Text size="x-small">
          If the screen freezes, page is refreshed, or the connection is lost, click this reconnect button
        </Text>
        <View as="div" padding="small">
          <Button
            color="primary"
            display="block"
            onClick={onReconnect}
            interaction={isReconnecting ? 'disabled' : 'enabled'}
          >
            {isReconnecting ? (
              <Flex alignItems="center" gap="x-small" justifyItems="center">
                <Spinner size="x-small" renderTitle="Reconnecting" />
                <Text size="small">Reconnecting...</Text>
              </Flex>
            ) : (
              'Reconnect'
            )}
          </Button>
        </View>
      </Card.Body>
    </Card>
  );
}

export default ConnectionToolsCard;
